<template>
  <ankh-list>
    <template #btn-group>
      <el-button @click.native="handleSaveSubmit">{{$t('保存更改')}}</el-button>
      <el-button @click.native="$refs.treeTable.handleChangeExpandState()">{{expandState ? $t('收起') : $t('展开')}}</el-button>
      <el-button @click.native="handleBatchDelete">{{$t('批量删除')}}</el-button>
    </template>

    <template #search-form>
      <el-form-item :label="$t('名称')">
        <el-input :placeholder="$t('名称')" v-model="searchForm.name" clearable/>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleSearch()">{{$t('搜索')}}</el-button>
        <el-button @click="resetEmpty()">{{$t('重置')}}</el-button>
      </el-form-item>
    </template>

    <template #table="{height}">
      <tree-table :column-list="columnList"
                  :data.sync="tableData"
                  :expand.sync="expandState"
                  :height="height" ref="treeTable"
                  :row-template="rowTemplate">
        <template #operate="{row}">
          <div class="fb-link-flex">
            <el-link type="danger" :underline="false" @click="handleDelete(row)">{{$t('删除')}}</el-link>
          </div>
        </template>
      </tree-table>
    </template>
  </ankh-list>
</template>

<script>
import {request} from "@/config/request";
import AnkhList from "@/components/list/AnkhList.vue";
import TreeTable from "@/components/tree-table/TreeTable.vue";
import {resetEmpty} from "@/utils/common";
import {handleBuildTreeData, handleDeleteTip, handleDeleteTreeNode} from "@/utils/levelUtils";

export default {
  name: "MakeTimeList",
  components: {TreeTable, AnkhList},
  data() {
    return {
      searchForm: {},
      tableData: [],

      expandState: true,

      columnList: [
        {label: "制作时长名称", prop: "name", type: "input", fixed: 'left', minWidth: "400"},
        {label: "移动", prop: "", type: "more", minWidth: "180"},
        {label: "默认展开", prop: "expand", type: "switch", minWidth: "100"},
        {label: "创建时间", prop: "createTimeStr", minWidth: "200"},
        {label: "操作", prop: "operate", minWidth: "100"},
      ],

      // 新增row 需要的字段数据
      rowTemplate: {
        name: "",
        expand: "yes",
        createTimeStr: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
      }
    }
  },
  methods: {
    resetEmpty,
    // 保存
    async handleSaveSubmit() {
      try {
        let params = this.handleBuildParams(this.tableData);
        await request(this.$api.cookDurationSort.save, params, {isJson: true});
        this.$message.success(this.$t('保存成功'));
        await this.handleSearch();
      }catch(e) {
        console.log(e);
      }
    },

    // 处理数据
    handleBuildParams(list) {
      return list.map((item, index) => {
        let sub = [];
        if(item.sub.length) {
          sub = this.handleBuildParams(item.sub);
        }
        return {
          name: item.name,
          code: item.isNewAdd ? null : item.code,
          sort: index + 1,
          expand: item.expand,
          sub,
        }
      })
    },

    async handleDelete(row) {
      try {
        await handleDeleteTip();
        if (!row.isNewAdd) {
          await request(this.$api.cookDurationSort.delete, {code: row.code});
        }
        this.tableData = handleDeleteTreeNode([row.code], this.tableData);
        this.$message.success(this.$t('操作成功'));
      } catch (e) {
        console.error(e);
      }
    },

    async handleBatchDelete() {
      const selected = this.$refs.treeTable.handleGetSelected();
      if (!selected.length) {
        this.$message({
          type: 'warning',
          message: this.$t('未选择记录')
        });
        return;
      }
      try {
        await handleDeleteTip();
        let codes = selected.filter(f => !f.isNewAdd).map(item => item.code);
        if (codes.length) {
          await request(
              this.$api.cookDurationSort.batchDelete,
              codes,
              {isJson: true},
          );
        }
        const delCodes = selected.map(item => item.code);
        this.$message.success(this.$t('操作成功'));
        this.tableData = handleDeleteTreeNode(delCodes, this.tableData);

      } catch (e) {
        console.error(e);
      }
    },

    // 搜索数据
    async handleSearch() {
      try {
        const params = {
          ...this.searchForm,
          onPage: false,
        }
        let res = await request(this.$api.cookDurationSort.list, params);
        this.tableData = handleBuildTreeData(res.cookDurationSorts, item => {
          return {
            createTimeStr: this.$moment(item.createTime).format("YYYY-MM-DD HH:mm:ss"),
          }
        });
      } catch (e) {
        console.error(e);
      }
    },
  },
  mounted() {
    this.handleSearch();
  }

}
</script>

<style scoped>

/deep/ .cell {
  display: flex;
  align-items: center;
}

</style>
